module.exports = __webpack_public_path__ + "img/416d582.svg";